import { motion } from "framer-motion";
export const initialState = {
  basket: [],
};

//Selector
export const getBasketTotal = (basket) =>
  basket?.reduce((amount, item) => item.price + amount, 0);

const reducer = (state, action) => {
  switch (action.type) {
    case "ADD_TO_BASKET":
      return {
        ...state,
        basket: [...state.basket, action.item],
      };

    case 'EMPTY_BASKET':
      return{
        ...state, basket: []
      }; 

    ///Look for an accurate remove
    case "REMOVE_FROM_BASKET":
      const index = state.basket.findIndex(
        (basketItem) => basketItem.id === action.id
      );
      let newBasket = [...state.basket];

      if (index >= 0) {
        
        newBasket.splice(index, 1);
      } else {
        console.warn(
          "Cant Remove product ${action.id} as its not in the basket"
        );
      }
      return {
        ...state,
        basket: newBasket,
      };

    
      
    case "SET_USER":
      return {
        ...state,
        user: action.user,
      };

    default:
      return state;
  }
};

export default reducer;
